import React from "react";
import { Table } from "antd";
import styled from "@emotion/styled";
import COLORS from "../../Common/Colors";

export const StyledTable = styled(Table)`
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
    /* border-radius: 10px; */
    color: #5f6d8c;
    font-size: 14px;
    font-weight: 400;
    height: 10% !important;
  }
  .ant-table-row:nth-child(even) {
    background-color: #fafafa;
    width: 1108px;
    height: 50px;
  }
  .normal-column {
    min-width: 300px;
    white-space: normal;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: bold;
    color: #363636;
    font-size: 14px;
    font-weight: 500;
    white-space: nowrap;
  }
  .non-white {
    background: #f9f9f9;
  }
  .custom-row {
    height: 100px;
  }
`;

const UITable = (props) => {
  return <StyledTable {...props} />;
};

export default UITable;
